import { IActivityBase } from '../../models/activities';
import { IProductBase } from '../../models/products';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateProductProps {
  productId: string;
  name: string;
  isActive: boolean;
  costCenter: string;
  productCode: string;
  productType: string;
  productNature: string;
  invoiceType: 'NF' | 'ND';
  description?: string;
}

export interface IUpdatedProduct extends IProductBase {
  activities: IActivityBase[];
}

export const updateProductsService = async ({
  productId,
  name,
  isActive,
  costCenter,
  productCode,
  productType,
  productNature,
  description,
  invoiceType,
}: IUpdateProductProps): Promise<IUpdatedProduct> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedProduct>(
    `/products/${productId}`,
    {
      name,
      isActive,
      costCenter,
      productCode,
      productType,
      productNature,
      description,
      invoiceType,
    },
  );

  return data;
};
